(() => {
  // In-memory cache for loaded pages
  let pagesCache = [];

  const observeIntersection = ($node, callback) => {
    const intersectionObserver = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio <= 0) return;
      
      if (typeof callback === 'function') {
        callback(entries);
      }
    });

    intersectionObserver.observe($node);
  };

  const convertStringToHTML = (str) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  };

  const loadProductCards = (res) => {
    const $res = convertStringToHTML(res);
    const $products = $res.querySelectorAll('.product-item');

    if (!$products.length) return;

    const productCardClass = document.querySelector('.product-item').className;

    // Add products to the list
    $products.forEach(($product) => {
      $product.className = productCardClass;
      document.querySelector('.product-list').insertAdjacentElement('beforeend', $product);
    });

    document.dispatchEvent(new CustomEvent('products:loaded'));
  };

  const fetchCollectionAndCache = async (url, nextPageIndex) => {
    const res = await fetch(url).then(res => res.text());
    const itemCache = pagesCache.find((item) => item.url === url);
    
    if (!itemCache) {
      pagesCache.push({
        index: nextPageIndex,
        url: url,
        res: res
      });
    }
    
    return res;
  };

  const loadCollection = async (url, nextPageIndex) => {
    // Check if page is in cache
    const cachedPage = pagesCache.find((item) => item.url === url);
    
    if (cachedPage) {
      return cachedPage.res;
    }

    // update url 
    // let url_params = new URLSearchParams(window.location.search);
    // url_params.set('page', nextPageIndex);
    // const new_url = `${window.location.pathname}?${url_params.toString()}`;
    // window.history.replaceState({}, '', new_url);
    
    return await fetchCollectionAndCache(url, nextPageIndex);
  };

  const initScrollEvents = () => {
    document.querySelectorAll('.product-item:not(.initialized)').forEach(($card) => {
      $card.classList.add('initialized');

      // capture scroll position before navigating
      $card.addEventListener('click', (e) => {
        const scrollPosition = window.scrollY || window.pageYOffset;
        sessionStorage.setItem('scrollPosition', scrollPosition);
      });
    });

    // Activate hover image
    if (window.imageFunctions?.showSecondaryImage) {
      window.imageFunctions.showSecondaryImage();
    }
  };

  const infiniteLoad = () => {
    if (!document.querySelector('.collection')) return;
    
    const $paginateWrapper = document.querySelector('.pagination');
    if (!$paginateWrapper) return;

    // Set full url (to account for filtering)
    $paginateWrapper.dataset.url = `${window.location.pathname}${window.location.search}`;

    const currentPage = JSON.parse($paginateWrapper.dataset.current_page);
    const pages = JSON.parse($paginateWrapper.dataset.pages);
    
    $paginateWrapper.style.opacity = 0;
    
    observeIntersection($paginateWrapper, async (entries) => {
      let currentPage = JSON.parse($paginateWrapper.dataset.current_page);
      const pages = JSON.parse($paginateWrapper.dataset.pages);
      
      if (currentPage < pages) {
        const nextPageIndex = currentPage + 1;
        $paginateWrapper.dataset.current_page = nextPageIndex;
        const baseUrl = $paginateWrapper.dataset.url;
        const nextPageUrl = `${baseUrl}${baseUrl.indexOf('?') === -1 ? '?' : '&'}page=${nextPageIndex}`; 
      
        const collectionRes = await loadCollection(nextPageUrl, nextPageIndex);
        loadProductCards(collectionRes);
      }
      else {
        showSoldoutCards();
      }
      
      console.log(entries, 'intersected', currentPage, pages);
    });

    // Restore scroll position if available
    const savedScrollPosition = sessionStorage.getItem('scrollPosition');
    if (savedScrollPosition) {
      window.scrollTo(0, parseInt(savedScrollPosition, 10));
      sessionStorage.removeItem('scrollPosition');
    }
  };

  const showSoldoutCards = () => {
    const $soldoutItems = [...document.querySelectorAll('[data-product-card-soldout]')];
    
    $soldoutItems.forEach($item => {
      $item.removeAttribute('data-product-card-soldout');
      $item.parentNode.appendChild($item);
    });
  };

  const DOMReady = () => {
    document.addEventListener('products:loaded', () => {
      initScrollEvents();
    });

    infiniteLoad();
    initScrollEvents();
  };

  document.addEventListener('DOMContentLoaded', DOMReady);
})();